import { render, staticRenderFns } from "./SectionPracticeMobile.vue?vue&type=template&id=eb639aac&"
import script from "./SectionPracticeMobile.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SectionPracticeMobile.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb639aac')) {
      api.createRecord('eb639aac', component.options)
    } else {
      api.reload('eb639aac', component.options)
    }
    module.hot.accept("./SectionPracticeMobile.vue?vue&type=template&id=eb639aac&", function () {
      api.rerender('eb639aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/SectionPracticeMobile.vue"
export default component.exports